import React, { Component } from "react";
import { Container, Header, Icon } from "semantic-ui-react";
import { Link } from "react-router";
import { app } from "../..";
class LaborAtAGlanceCard extends Component {
  constructor() {
    super();
    this.state = {
      pto: null
    };
  }
  componentDidMount() {
    this.getptoinfo(this.props.myinfo.empnumber);
  }
  getptoinfo(empnumber) {
    app
      .service("reports")
      .find({
        query: {
          report: "pto",
          empnumber: empnumber
        }
      })
      .then(response => {
        console.log("PTO Report", response);

        if (response.length) {
          response = response[0];
          this.setState({
            pto: response
          });
        } else {
          this.setState({
            pto: "none"
          });
        }
      })
      .catch(err => console.log("PTO Report", err));
  }
  genHeader() {
    if (this.props.mobile !== true) {
      return (
        <Header as="h3">
          <Icon name="balance" />
          Labor Overview
        </Header>
      );
    }
  }
  handlepto() {
    if (this.props.myinfo.ptobalance) {
      return (
        <strong>
          {" " + this.props.myinfo.ptobalance.toFixed(2) + " hrs"}
        </strong>
      );
    } else {
      return <strong> 0 hrs </strong>;
    }
  }
  render() {
    return (
      <Container>
        {this.genHeader()}
        Hours this week:
        <strong>
          {this.props.weekhours}
          hrs
        </strong>
        <br />
        PTO Remaining:
        <strong>{this.state.pto ? this.state.pto.ptobalance : "none"}</strong>
        <br />
        <Link to="/time-entry"> Update </Link>
      </Container>
    );
  }
}
export default LaborAtAGlanceCard;



// WEBPACK FOOTER //
// ./src/components/home-components/laborglance.js